import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "antd";
import { setSelectedStudentId } from "../../../redux/slicers/studentSlice";
import { RootState } from "../../../redux/store";
import { useTranslation } from "react-i18next";

interface StudentSelectorWrapperProps {
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
}

const StudentSelectorWrapper: React.FC<StudentSelectorWrapperProps> = ({
  children,
  rightSlot
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector((state: RootState) => state.authSlice.user);
  const students = useSelector((state: RootState) => state.student.students);
  const selectedStudentId = useSelector((state: RootState) => state.student.selectedStudentId);

  const isGuardian = user?.role === "guardian";

  // Auto-select first student if none selected
  useEffect(() => {
    if (isGuardian && students.length > 0 && !selectedStudentId) {
      dispatch(setSelectedStudentId(students[0].id));
    }
  }, [dispatch, isGuardian, students, selectedStudentId]);

  if (!isGuardian) {
    return <>{children}</>;
  }

  return (
    <>
      <div className="mb-3 d-flex justify-content-end" style={{ gap: '10px' }}>
        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
          <Select
            style={{
              width: 250,
              height: 38,
            }}
            value={selectedStudentId || undefined}
            placeholder={t("select_student") || "Select a student"}
            onChange={(value) => dispatch(setSelectedStudentId(value))}
            options={students.map((student: any) => ({
              label: `${student.firstName} ${student.lastName}`,
              value: student.id,
            }))}
          />
        </div>

        {rightSlot && (
          <div className="d-flex align-items-center">
            {rightSlot}
          </div>
        )}
      </div>

      {/* Render children if student selected, else show message */}
      {selectedStudentId ? (
        children
      ) : (
        <p className="text-danger text-center">
          {t("select_student_first")}
        </p>
      )}
    </>
  );
};

export default StudentSelectorWrapper;